import React, { useState } from 'react';
import axios from 'axios';

interface Props {
  proceduraId: number;
}

export function ChatVerbali({ proceduraId }: Props) {
  const [aperto, setAperto] = useState(false);
  const [domanda, setDomanda] = useState('');
  const [risposta, setRisposta] = useState<string | null>(null);
  const [caricamento, setCaricamento] = useState(false);
  const [errore, setErrore] = useState<string | null>(null);

  const inviaDomanda = async () => {
    if (!domanda.trim() || caricamento) return;
    setCaricamento(true);
    setErrore(null);
    setRisposta(null);
    try {
      const token = localStorage.getItem('reconcilia_token');
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL || 'https://firmereconcilia.it'}/api/procedure/${proceduraId}/chat`,
        { domanda },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setRisposta(res.data.risposta);
      setDomanda('');
    } catch (e: any) {
      setErrore(e.response?.data?.detail || 'Errore nel chatbot');
    } finally {
      setCaricamento(false);
    }
  };

  return (
    <div style={{ marginTop: '1rem', borderTop: '1px solid #e0e0e0', paddingTop: '0.8rem' }}>
      <button
        onClick={() => setAperto(a => !a)}
        style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: '0.9rem', color: '#2563eb', padding: 0, fontWeight: 'bold' }}
      >
        💬 {aperto ? 'Chiudi chat verbali' : 'Chiedi ai verbali'}
      </button>

      {aperto && (
        <div style={{ marginTop: '0.8rem' }}>
          <div style={{ display: 'flex', gap: '0.5rem' }}>
            <input
              type="text"
              placeholder="Es: Cosa è successo all'ultimo incontro?"
              value={domanda}
              onChange={e => setDomanda(e.target.value)}
              onKeyDown={e => e.key === 'Enter' && inviaDomanda()}
              disabled={caricamento}
              style={{ flex: 1, padding: '0.4rem 0.6rem', borderRadius: '4px', border: '1px solid #ccc', fontSize: '0.85rem' }}
            />
            <button
              onClick={inviaDomanda}
              disabled={caricamento || !domanda.trim()}
              style={{ padding: '0.4rem 1rem', background: '#2563eb', color: 'white', border: 'none', borderRadius: '4px', cursor: caricamento || !domanda.trim() ? 'not-allowed' : 'pointer', opacity: caricamento || !domanda.trim() ? 0.6 : 1, fontSize: '0.85rem' }}
            >
              {caricamento ? '⏳' : 'Chiedi'}
            </button>
          </div>

          {errore && (
            <div style={{ marginTop: '0.5rem', padding: '0.5rem 0.8rem', background: '#fdecea', borderRadius: '4px', color: '#c00', fontSize: '0.85rem' }}>
              ❌ {errore}
            </div>
          )}

          {risposta && (
            <div style={{ marginTop: '0.8rem', padding: '0.8rem', background: '#f0f7ff', borderRadius: '4px', fontSize: '0.85rem', lineHeight: '1.6', whiteSpace: 'pre-wrap' }}>
              <strong>📝 Risposta:</strong>
              <div style={{ marginTop: '0.4rem' }}>{risposta}</div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
